import { render, staticRenderFns } from "./CarisBar.vue?vue&type=template&id=7b807882&scoped=true"
import script from "./CarisBar.vue?vue&type=script&lang=js"
export * from "./CarisBar.vue?vue&type=script&lang=js"
import style0 from "./CarisBar.vue?vue&type=style&index=0&id=7b807882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b807882",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcaris-bar%2FCarisBar.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports